import sharia from "./sharia_law_postgraduate.pdf"

const backet =
  "https://bu-page-assets.s3.ap-northeast-1.amazonaws.com/static-assets";


// const cover =  backet + '/others/cover.jpeg'

const icon1 = backet + "/postgrad/icons/writing.png";
const icon2 = backet + "/postgrad/icons/clock.png";
const icon3 = backet + "/postgrad/icons/fee.png";
const icon4 = backet + "/postgrad/icons/calendar.png";
const icon5 = backet + "/postgrad/icons/award.png";
const icon6 = backet + "/postgrad/icons/enter.png";
const icon7 = backet + "/postgrad/icons/requirement.png";
const icon8 = backet + "/postgrad/icons/choices.png";
const icon9 = backet + "/postgrad/icons/mortarboard.png";


export const bfDetail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `A master’s degree in Banking and Finance (MBF) is a graduate-level program that focuses on the intricate financial aspects of the banking sector. This program offers students an in-depth understanding of financial theory, quantitative analysis, and financial strategy, and prepares them to excel in various roles in the banking and finance industry.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three semesters with in 18 Months `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 2000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Graduates from this program will be awarded to a Master of Science in Banking and Finance, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
      1. Processing fee of USD $ 100
      2. Two (2) copies of photos with white background
      3. Original of Secondary School certificate,
      4. Original of Bachelor certificate & Transcript
      5. Two (2) Recommendation letters from your Previous university  
      6. He/ She should have bachelor degree in Banking and Finance or related programs
      7. At least 2 years Work experience in related Field Areas`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Target / Potential Students ",
    desc: `
      1.	Graduates with a Bachelor's degree in finance, economics, business administration, or a related field
      2.	Professionals working in the banking and financial industry seeking to enhance their knowledge and skills.
      3.	Individuals with a strong quantitative background and analytical skills
      4.	Individuals seeking to develop expertise in financial markets, portfolio management, financial modeling, and financial analysis.
      5.	Students with a goal of pursuing a Ph.D. in finance or conducting research in the field of banking and finance.
      `,
    icon: icon7,
  },
  {
    id: 8,
    title: "Career Options",
    desc: `Graduates of these programs are prepared for leadership roles in a wide range of industries, including finance, consulting, manufacturing, healthcare, technology, and more.`,
    icon: icon9,
  },
];

export const pmDetail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `This program provides sufficient knowledge, skills, competencies, and behavior attitudes that can enable to implement projects effectively and effectively.
    A master’s degree in project management is a graduate-level program that teaches students the skills and knowledge needed to effectively manage complex projects, both large and small. The curriculum focuses on a range of topics, including project planning, risk management, stakeholder management, budget control, team management, and project evaluation.
    `,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three semesters with in 18 Months `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 2000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Science in Project Management, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous university  
    6. He/ She should have bachelor degree in Banking and Finance or related programs
    7. At least 2 years Work experience in related Field Areas`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Career Options",
    desc: `Graduates of a master’s degree in project management (MPM) can work in a variety of industries, including construction, aerospace, IT, engineering, finance, healthcare, and manufacturing. They can find positions as project managers, program managers, project coordinators, consultants, and team leaders.`,
    icon: icon9,
  },
];

export const paDetail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `A master’s degree in public administration (MPA) is a graduate-level degree program that provides students with the knowledge, skills and practical experience needed to work in various fields of public administration. The program provides students with a broad understanding of the principles and practices of public administration, including management, policy development, program evaluation, and budgeting.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three semesters with in 18 Months`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 2000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Science in Public Administration, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous university  
    6. He/ She should have bachelor degree in in public administration or related programs
    7. At least 2 years Work experience in related Field Areas`,
    icon: icon6,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Graduates of an MPA program can pursue careers as public administrators, policy analysts, program evaluators, budget analysts, or executives in various fields of public service.`,
    icon: icon9,
  },
];
export const baDetail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `A Master of Business Administration (MBA) is a graduate degree program that focuses on the management of business operations. The program includes courses in areas such as accounting, finance, marketing, human resources management, leadership, and strategy.
    An MBA program provides students with advanced skills and knowledge in business operations, strategy, and decision-making. Students learn how to analyze complex business situations and develop strategies to address the challenges facing organizations in today's global economy. The curriculum emphasizes critical thinking, communication, problem-solving, leadership, and ethics.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three semesters with in 18 months`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 2000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Science in Business Administration, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous university  
    6. He/ She should have bachelor degree in in public administration or related programs
    7. At least 2 years Work experience in related Field Areas`,
    icon: icon6,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Graduates of MBA programs are prepared for leadership roles in a wide range of industries, including finance, consulting, manufacturing, healthcare, technology, and more`,
    icon: icon9,
  },
];
export const raDetail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The Master of Applied Statistics and Research Methods program is designed to prepare students for a wide range of careers in the fields of statistics, data analysis, and research methodology. Graduates of this program will have the knowledge and skills necessary to work in a variety of settings, including government agencies, research institutes, non-profit organizations, and private companies.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three semesters with in 18 months`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 2000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Science in Applied Statistics and Research Methodology, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous university  
    6. He/ She should have bachelor degree in Statistics and Planning or related programs
    7. At least 2 years Work experience in related Field Areas`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Career Options",
    desc: `Graduates of this program can pursue a wide range of career options, such as data analysts, statisticians, research analysts, market researchers, and quantitative analysts. They can work in various sectors, including government, healthcare, finance, research institutions, and consulting firms. A master’s degree in research and applied Statistics provides a strong foundation for further studies, including doctoral programs in statistics, data science, or related fields.`,
    icon: icon9,
  },
];

export const vet_Epid_Detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `Veterinary epidemiology is the study of the distribution and determinants of animal health welfare and production related states or events in specified populations and the application of this study to control of health problems.\nVeterinary science deals with the health and wellbeing of animals. Like medical degrees, this encompasses everything from preventative care to psychological analysis and complex surgical procedures.\nVeterinary epidemiology focuses on the description and analysis of disease within a population. This means that veterinary epidemiologists look at the effect and the development of disease in a population to better understand the origin, the transmission of that disease.
      `,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `The MSc program is a two-year program.\nAll students will have one year (2 semesters), taught course and one year for a research project in a specific area of specialization.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration fee : $ 100.\nTuition fee (year) : $ 1200$`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `Intake 1:  September.\nIntake 2:  March.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `The Degree of Master of Science in “Veterinary Epidemiology”`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `Applicants must have completed the academic requirements for the Bachelor's degree in veterinary sciences (BVSc), or other related sciences (Biological sciences, human medicine and mathematical or statistician) from accredited higher learning institutions.\nThe candidate must pass qualifying (entrance) examination of the University.`,
    icon: icon6,
  },

  {
    id: 7,
    title: "Career Options",
    desc: `Private practitioner
      Researcher
      Academia
      Diagnostic Laboratories
      Veterinary public health
      Consultancy
      Government (Federal or State)
      International employer`,
    icon: icon9,
  },
];

export const vet_Nutr_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `Master degrees in Animal Nutrition studies the dietary needs of animals, looking at the ways in which they can be kept healthy.\nAnimal nutrition entails the study of the composition and characteristics of the material consumed by the animal, the manner in which this material is metabolized (converted, utilized, and excreted) in the digestive tract and body cells of monogastric animals (pigs, broilers, layers), ruminants (sheep, cattle, goats).\nDeficiencies and malnutrition severely impact animals' growth, development, and production; some extreme cases can lead to irreversible health conditions, disorders, or even fatalities. Nutrition-related diseases have actually become more of a problem due to modern farming techniques
      `,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `The MSc program is a two-year program for regular students.\nAll students will have one year (2 semesters), taught course and one year for a research project in a specific area of specialization.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration fee : $ 100.\nTuition fee (year) : $ 1200$`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `Intake 1:  September.\nIntake 2:  March.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `The Degree of Master of Animal Nutrition and Feed Science`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `Applicants must have completed the academic requirements for the Bachelor's degree in veterinary sciences (BVSc), or other related sciences (Biological sciences, and agriculture) from accredited higher learning institutions.\nThe candidate must pass qualifying (entrance) examination of the University.
    `,
    icon: icon6,
  },

  {
    id: 7,
    title: "Career Options",
    desc: `Private practice
    Animal Nutritionist
    Animal Feed Suppliers
    Feed manufactures
    Researcher
    Academia
    Commerce
    Consultancy
    Wildlife management
    Zoo
    International employment`,
    icon: icon9,
  },
];

export const tropicalDiseaseDetail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `Infectious pathogens which include bacteria, viruses, parasites and fungi are the most frequent and life threatening health problems occurring in tropical countries. Of these, the human immunodeficiency virus (HIV), malaria and pulmonary tuberculosis cause the highest morbidity and mortality in populations leaving in the tropics. Many others considered neglected and/or emerging are endemic and frequently cause epidemics further complicating the already worsened situations in resource-limited countries. Similarly pandemics of viral natures are potentially creating Public Health of International Concern, and predicting them requires meticulous knowledge on the epidemiology of Infectious diseases coupled with properly equipped laboratories. The Masters course in Tropical and Infectious Diseases is designed to address one aspect in the control process by training personnel who will form core infectious disease control teams consisting of physicians, dentists, pharmacists, nurses, epidemiologists and biologists capable of predicting disease outbreak, carrying out disease surveillance and controlling disease epidemics.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `2 years`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registration fee:100\nTuition Fee per Semester: $1000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `Intake 1:  September.\nIntake 2:  March.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Graduates from this program will be awarded to a Master in Tropical and Infectious Diseases (MITD), Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `1. Processing fee of USD $ 100\n2. Two (2) copies of photos with white background\n3. Original of Secondary School certificate\n4. Original of Bachelor certificate & Transcript.\n5. Two (2) Recommendation letters from your Previous University \n6. He/ She should have bachelor degree in Medicine, Health science and bachelor degree in Field or related programs.`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `The Master of Science degree course in Tropical and Infectious Diseases shall cover a minimum of four (4) semesters and a maximum of ten (10) semesters of fifteen (15) weeks each. A candidate shall be required to take a minimum of three (3) course units and a maximum of five (5) course units in a semester. The course shall consist of fifteen (15) units of sixty (60) hours each, a practicum and project. The course shall be conducted through lectures, seminars, tutorials, laboratory and practical. The first year of study shall be by course work, tutorial, seminars, continuous assessment and end of year examinations. A candidate shall only proceed to the second year of study after successful completion of the first year examination. In the second year of study, candidates shall take up an attachment /practicum in a discipline of their interest. They shall develop a research proposal so as to conduct original research, write a dissertation and sit for the final year examinations.`,
    icon: icon7,
  },
  {
    id: 8,
    title: "Career Options",
    desc: `The established core teams will be expected to work closely with the relevant Hospitals to diagnose and treat patients, will also work closely with government ministries to combat and control diseases. They will also be expected to work with non-governmental organizations (NGOs) and other international agencies such as the World Health Organization (WHO), Food and Agriculture Organization (FAO) and others.`,
    icon: icon9,
  },
];


export const healthySystemMgtDetail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `1)	This course covers the key issues involved in health system management. It examines and unpicks the concepts of management, health care funding, human resource management, performance management, change management and managerial leadership in the context of delivering effective health care services. It provides an understanding, both theoretical and practical, of the managerial processes and skills that are required to achieve these tasks.\n2)	The aim of this course is to produce health professionals and other managerial cadres who possesses effective managerial capacity to deliver healthcare services and improve health outcomes of the country as well as managing the health system at different levels district, state and central.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Two years`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `USD 750 (seven hundred and fifty dollars per semester)`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September each year as per university calendar`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Science in Health System Management (MSc HSM)`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `University degree preferably in health science or management`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Career Options",
    desc: `Graduates of health system management professionals are highly demanded in many levels and are mainly recruited as department heads or director general for ministries of health and they also hired by international health agencies like non-governmental or united nations agencies.`,
    icon: icon9,
  },
];

export const publicHealthNutritionDetails = [
  {
    id: 1,
    title: "Course Overview",
    desc: `Malnutrition remains a major public health problem and a priority area for targeted health intervention. Many strategies and interventions have been implemented with little or no success in reducing the unacceptably high rates of malnutrition and the attributable mortality and morbidity. Among the strategies recommended for nutrition improvement in Somalia is the development of human resources with competencies to promote nutrition with spin off benefits to health and socio- economic status of the community.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Two(2) years.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Program fee is 1500 Dollars /year.`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `This takes place In September every year at the starting of the university academic year.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `The Degree of Master of Public Health Nutrition is awarded to candidates who have passed all the courses and the dissertation.`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `1. A good bachelor’s degree Public Health, Nutrition, Nursing, Midwifery and Laboratory &Medicine and Surgery.\n2. A good overall academic transcript.\n3. Good spoken and written English language.\n4. Applicants are also required to satisfy other standing university regulations.`,
    icon: icon6,
  },
  
];


export const pediatricDetails = [
  {
    id: 1,
    title: "Course Overview",
    desc: `Children under the age of 15 years comprise about 50% of the population in most developing countries, while 20% of the population consists of under fives. The need for doctors with specialist training in Pediatrics and Child Health in Somalia was recognized in the 2017 and training started in March 2017. However, this need still remains because of the high morbidity and mortality among children, especially under-fives in the country.\nThe Department of Pediatrics and Child Health, in collaboration, implements the course with other departments in the college of Health Sciences (such as Medicine, Pathology, Microbiology, Obstetrics and Gynecology and the School of Public Health, Surgery, Psychiatry).\nThe Master of Medicine in Pediatrics and Child Health is a three-year program aimed at training specialists in Pediatrics and Child Health. The educational goals of this course are to impart a broad working knowledge of Pediatrics and the pathophysiology of disease and skills to enable the graduate to utilize the knowledge in clinical situations and research.\nThe overall goal of the course is to produce a good pediatrics specialist doctor. The MMed. (Pediatrics and Child Health) programme is designed to address this need.\nThe Pediatrician and child health specialist in a resource poor country like Somalia has many roles, which include diagnosis, management, and prevention of diseases of children, promotion of child health and advocacy for children’s rights, research, and training. This means that the pediatrician must be both clinically sound and able to recognize the wider community and societal issues involved in the causation of child health problems. They should be aware of the need for innovative multi sectoral programmes to improve the life and health of children and their families.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `The programme is a full time three-year programme conducted during day and evening on a credit unit basis. The curriculum offers only one plan – known as Plan A in which a student is required to write an MMed in Pediatrics and Child Health Dissertation. In this curriculum, students are required to undertake eight semesters inclusive of two recess semesters. The students undertake both supervised and unsupervised clinical practice in Out-and In-patient services. In additionstudents carry out practical laboratory procedures.\nAs students advance in years of training, we expect an increase in level of competence in all the courses taught in the semester system. The duration of Semester is 17 weeks inclusive of 1 week for exam.\nThe M.Med programme in Pediatrics and Child Health extends over a period of at least three years.\nThe maximum period allowed for this course is five (5) years. `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Program fee is $ 1800 /year.\nPayment options:
    Option 1: Full program fee can be paid in advance at once for the entire academic year.
    Option 2: Tuition fee can also be paid twice a year before each semester begins.
    That means $ 900 /semester`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `This takes place In September every year at the starting of the university academic year.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `The Degree of Master of Medicine (MMed) in Pediatrics and Child Health is awarded to candidates who have passed all the courses and the dissertation.
    "Master of Medicine in Pediatrics and Child Health MMed. (Pediatrics & Child Health)"`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `1. A good bachelor’s degree in Medicine and Surgery (MBChB)\n2. A good overall academic transcript.\n3. At least one year of post internship service preferably in a recognized hospital/health
    center.\n4. Post registration working experience in a medical department of a recognized hospital or
    program will be an added advantage but not a pre-requisite.\n5. Good spoken and written English language.\n6. Applicants are also required to satisfy other standing university regulations.`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Career Options",
    desc: `Becoming an Pediatrics and Child Health Specialist is not an easy job for all. You will have to handle multi-discipline medical complications and offer care to patients who are critically ill.\nThough not an easy job, the profile certainly offers engagement and recognition in all possible aspects of life.\nIn addition to providing longitudinal patient care, conducting research, and leading teams in clinical environments, Pediatrics and Child Health specialist thrive in leadership roles at hospitals and health care systems, and in business, technology, and public policy.Well, that is just not it; you also be in a career that is highly rewarding and demanding in society.\nYou will be able to be a part of a team of experts who are skilled in offering the best quality standards of management and communication while in private and public workplace.`,
    icon: icon9,
  },
];


export const master_private_law_Details = [
  {
    id: 1,
    title: "Course Overview",
    desc: `A Master's in Private Law program is designed to provide students with an in-depth understanding of legal principles and concepts related to private relationships and transactions. The curriculum typically covers a wide range of topics in civil law, contract law, property law, and other areas of private law, preparing students for careers in legal practice, academia, and other professional roles. Here's an overview of the typical course structure and subjects you might encounter in a Master's in Private Law program. Overall, a Master's in Private Law program provides students with a comprehensive understanding of private law principles and their application in legal practice and other professional contexts. Graduates are prepared for careers as legal practitioners, consultants, academics, or policymakers in the field of private law.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three (3) Semesters `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration fee : $ 100.\nTuition fee (year) : $ 2000$`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September every year.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Private Law from Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original and copy of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous University
    6. He/ She should have bachelor degree in Sharia & Law
    `,
    icon: icon6,
  },
  {
    id: 8,
    title: "Program outline",
    desc: `The Master's in Private Law program offers a balance of foundational courses, elective options, and practical experiences to prepare students for careers in legal practice, academia, and other professional roles in the field of private law. Actual program structures may vary depending on the institution and specific program requirements. The curriculum often covers a broad range of topics related to Commercial Arbitration and Investment Disputes, International Trade law Commercial Companies law copyright law, banking law, and other areas relevant to the functioning of private organizations.`,
    icon: icon7,
  },
  {
    id: 7,
    title: "Career Options",
    desc: `A Master's in Private Law opens up a variety of career opportunities in legal practice, academia, government, and the private sector. Here are some common career paths for individuals with a Master's in Private Law: Private Practice Lawyer, Legal Consultant, Government Lawyer, Policy Analyst/Advisor, Corporate Compliance Officer, Legal Publishing and Journalism and Non-Governmental Organizations (NGOs) and International Organizations. These are just a few examples of the many career paths available to individuals with a Master's in Private Law. Graduates may also pursue entrepreneurial ventures, interdisciplinary roles, or other non-traditional career paths that leverage their legal expertise and skills.
Download the info table <a href=${sharia} classname="text-blue-600 hover:underline" target="_blank">here</a>`,
    icon: icon9,
  },
];
export const master_public_law_Details = [
  {
    id: 1,
    title: "Course Overview",
    desc: `A Master of Public Law program typically provides students with an in-depth understanding of the legal frameworks and principles governing public institutions, governance structures, and regulatory processes. The curriculum often covers a broad range of topics related to constitutional law, administrative law, regulatory law, human rights law, international law, and other areas relevant to the functioning of governments and public organizations. Throughout the program, students may also have opportunities to engage in practical learning experiences, such as internships, moot court competitions, or legal clinics, where they can apply their knowledge in real-world settings and develop practical skills for careers in public law and governance.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three (3) Semesters `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration fee : $ 100.\nTuition fee (year) : $ 2000$`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September every year.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Public Law from Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original and copy of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous University
    6. He/ She should have bachelor degree in Sharia & Law
    `,
    icon: icon6,
  },
  {
    id: 8,
    title: "Program outline",
    desc: `This outline provides a structured framework for a Master of Public Law program, offering a balance of foundational courses, advanced seminars, elective options, and practical experiences to prepare students for careers in public law and governance. Actual program structures may vary depending on the institution and specific program requirements. Certainly! Here's a sample program outline for a Master of Public Law: Constitutional Law, International water and sea Law and Internship or Practicum Optional practical experience placement with a government agency, nonprofit organization, or law firm, providing hands-on exposure to public law practice and policy and Thesis Research and Writing.`,
    icon: icon7,
  },
  {
    id: 7,
    title: "Career Options",
    desc: `A Master of Public Law degree equips graduates with a strong understanding of legal frameworks, governance structures, and regulatory processes, opening up various career opportunities in both the public and private sectors. Here are some common career paths for individuals with a Master of Public Law: Government Lawyer, Policy Analyst/Advisor, and Legal Counsel for Nonprofit Organizations, Judicial Clerkship, International Organizations and Academic and Research Positions. Overall, a Master of Public Law degree offers diverse career paths in law, policy, and governance, providing graduates with the knowledge and skills to make meaningful contributions to the public good in various professional settings.
Download the info table <a href=${sharia} classname="text-blue-600 hover:underline" target="_blank">here</a>`,
    icon: icon9,
  },
];
export const master_jurispudence_Details = [
  {
    id: 1,
    title: "Course Overview",
    desc: `A Master's in Islamic Jurisprudence, also known as a Master's in Islamic Fiqh, is a specialized program that focuses on Islamic legal principles and their application in contemporary legal contexts. The program typically covers a range of topics related to Islamic law, jurisprudence, legal theory, and the role of Islamic law in society. In general, a Master's in Islamic Jurisprudence program provides students with a deep understanding of Islamic legal principles and their application in contemporary legal contexts. Graduates are prepared for careers in legal practice, academia, government, and international organizations, where knowledge of Islamic law is valuable`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three (3) Semesters `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration fee : $ 100.\nTuition fee (year) : $ 2000$`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September every year.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master's in Islamic Jurisprudence from Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original and copy of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous University
    6. He/ She should have bachelor degree in Sharia & Law
    `,
    icon: icon6,
  },
  {
    id: 8,
    title: "Program outline",
    desc: `This outline provides a structured framework for a Master's in Islamic Jurisprudence program, offering a balance of foundational courses, elective options, and practical experiences to prepare students for careers in legal practice, academia, government, and international organizations. Actual program structures may vary depending on the institution and specific program requirements.    Here's an overview of the typical course structure and subjects you might encounter in a Master's in Islamic Jurisprudence program: Fiqh of comparatives transaction, rules of Fiqh integral goals of sharia , principle of agreement and disagreement of scholars , Fiqh of contemporary issue, comparative criminal Fiqh.`,
    icon: icon7,
  },
  {
    id: 7,
    title: "Career Options",
    desc: `A Master's in Islamic Jurisprudence can lead to a variety of career opportunities in legal practice, academia, government, and international organizations. Here are some common career paths for individuals with a Master's in Islamic Jurisprudence. These are just a few examples of the many career paths available to individuals with a Master's in Islamic Jurisprudence. Graduates may also pursue entrepreneurial ventures, advocacy work, or other non-traditional career paths that leverage their expertise in Islamic law.
Download the info table <a href=${sharia} classname="text-blue-600 hover:underline" target="_blank">here</a>`,
    icon: icon9,
  },
];

export const general_surgery_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The Master of Medicine in General Surgery is aimed at providing a thorough grounding in Clinical Surgery to produce future medical teachers, researchers and consultants in Somalia in particular and the region as a whole. The degree should be taken as an index of suitability for continuing training, rather than just for conferring the right of implying adequacy for immediate promotion to consultant status. The programme is designed to pass out those surgeons in training who have a broad knowledge of surgical problems in general and who are capable of recognizing and dealing safely and efficiently with the whole range of surgical conditions, which may be handled by the Trainee Surgeons. The Trainee should have the basic surgical skills, which are essential in confidently handling emergency surgical admissions independently, and deal with life threatening situations from traumatic and other critical diseases. The Trainee Surgeon should be able to accurately diagnose and plan management of a wide variety of surgical diseases even in situations where investigative and/or therapeutic facilities are limited.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three (3) years.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 1800`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Medicine in General Surgery.`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous University
    6. He/ She should have bachelor degree in Medicine
    7. At least 1 years Work experience in related Field Areas.`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `The Master of Science degree course in General Surgery shall cover a minimum of Six (6) semesters and a maximum of ten (10) semesters of fifteen (15) weeks each. A candidate shall be required to take a minimum of three (3) course units and a maximum of five (5) course units in a semester. The course shall consist of fifteen (15) units of sixty (60) hours each, a practicum and project. Progressive assessment is based on clinical care of patients, case write-ups and presentations as well as thoroughness of clinical records. The most crucial clinical skills and procedures will be assessed through the use of assessment cards and or a log book designed by the department. An external examiner is present at the examinations of the year 3, semester 2 courses.                                                                       The programme shall be offered on full time basis. All the subjects covered will involve lectures, clinical work, clinical teachings, surgical skills, seminars, conferences, demonstrations, tutorials and teaching in a skills laboratory.  The first year of study shall be by course work, tutorial, seminars, continuous assessment and end of year examinations. A candidate shall only proceed to the second year of study after successful completion of the first year examination. In the second year of study, candidates shall take up an attachment /practicum in a discipline of their interest. They shall develop a research proposal so as to conduct original research, write a dissertation and sit for the final year examinations. Candidates will also be expected to have a sound knowledge of pharmacology in relation to surgical practice and of the action of the more important substances in use such as anesthetics, antibiotics, analgesics, steroids and those drugs acting on the autonomic, vascular and pulmonary systems. Some basic knowledge is expected about the effects of radiation on the body and the use of radioactive isotopes. In Biochemistry, a detailed knowledge of chemical analysis, reactions and synthesis is not expected but knowledge of biochemistry which enables them to understand the effects of common surgical diseases and injuries upon the normal structure and function of the various systems of the body will be expected. The Trainees will be required to understand the basic principles underlying disease processes. They must have an understanding of the General Pathology, including the principles of Immunology`,
    icon: icon7,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Working in General Surgery provides plenty of career opportunities and personal development within the medical profession, with opportunities both in surgical and medical.  Clinical and operative competence in both emergency and elective General Surgery, In addition they require knowledge and experience across a wide range of surgery to ensure appropriate referral. In addition they require knowledge and experience across a wide range of surgery to ensure appropriate referral. They will have ability to work as a member of a clinical team, bearing in mind the needs of the service and the hospital. They will be able to publicly communicate with other health workers at scientific meetings.`,
    icon: icon9,
  },
];


export const internal_medicine_Details = [
  {
    id: 1,
    title: "Course Overview",
    desc: `There is already existing high burden of infectious disease generally in Africa and particularly in Somalia adding an increase of non-communicable diseases. In order to tackle these conditions, there is need for an increase in number of doctors equipped with adequate knowledge to manage these conditions and carryout research in medical field. The Master of Medicine in Internal Medicine is a three-year program aimed at training specialists in Internal Medicine. The educational goals of this course are to impart a broad working knowledge of internal medicine and the pathophysiology of disease and skills to enable the graduate to utilize the knowledge in clinical situations and research. The overall goal of the course is to produce a good internal medicine specialist doctor.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three (3) years.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 1800`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Medicine in Internal Medicine`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous University
    6. He/ She should have bachelor degree in Medicine
    7. At least 1 years Work experience in related Field Areas.`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `The Master of Science degree course in Internal Medicine shall cover a minimum of Six (6) semesters and a maximum of ten (10) semesters of fifteen (15) weeks each. A candidate shall be required to take a minimum of three (3) course units and a maximum of five (5) course units in a semester. The course shall consist of fifteen (15) units of sixty (60) hours each, a practicum and project. Progressive assessment is based on clinical care of patients, case write-ups and presentations as well as thoroughness of clinical records. The most crucial clinical skills and procedures will be assessed through the use of assessment cards and or a log book designed by the department. An external examiner is present at the examinations of the year 3, semester 2 courses. The course shall be conducted through lectures, seminars, tutorials, laboratory and practical. The first year of study shall be by course work, tutorial, seminars, continuous assessment and end of year examinations. A candidate shall only proceed to the second year of study after successful completion of the first year examination. In the second year of study, candidates shall take up an attachment /practicum in a discipline of their interest. They shall develop a research proposal so as to conduct original research, write a dissertation and sit for the final year examinations.`,
    icon: icon7,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Becoming an Internal Medicine Specialist is not an easy job for all. You will have to handle multi-discipline medical complications and offer care to patients who are critically ill. Though not an easy job, the profile certainly offers engagement and recognition in all possible aspects of life.  In addition to providing longitudinal patient care, conducting research, and leading teams in clinical environments, Internal Medicine specialist thrive in leadership roles at hospitals and health care systems, and in business, technology, and public policy.  Well, that is just not it; you also are in a career that is highly rewarding and demanding in society. You will be able to be a part of a team of experts who are skilled in offering the best quality standards of management and communication while in private and public workplace.`,
    icon: icon9,
  },
];

export const medical_lab_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `This programme is comprised of advanced training in the fields of laboratory science and the core modules included are: microbiology, biochemistry, hematology and a thesis which is completed in the final semester.  The thesis equips the students with an opportunity to apply their knowledge and to develop competence in their preferred topic. `,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `2 years`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 1400`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September Intake`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Medical Laboratory Science in Cytopathology `,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `To apply this degree, you need to have the following:
    1. Secondary school certificates or equivelent document. 
    2. Bachelor’s degree in medical laboratory.`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `This program follows a semester system which there are 4 semesters, in which each semester is 16 weeks, out of this 16 weeks, 15 weeks consists of tutoring and the last week is for examinations.		`,
    icon: icon7,
  },
  {
    id: 8,
    title: "Career Options",
    desc: `There are numerous career options with a Master of Medical Laboratory Science in cytopathology where an individual with this qualification can see themselves working in both government and private hospitals as a research scientist. With the increasing incidence of neoplasms in Somalia both rural and urban cities an individual with this degree will be able to prevent and screen for cancers of the cervix, breast, thyroid and urinary tract.`,
    icon: icon9,
  },
];

export const obs_gyno_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `Obstetrics & Gynecology is a branch of medicine that deals majorly with women health. It focuses on anatomical, physiological, endocrinology, psychology and pathology of the reproductive system of women and men. The training encompasses the art of instilling knowledge, skills and attitude in the trainees so as to offer holistic care to both pregnant and non-pregnant women both locally in Somalia and abroad. The ultimate goal of this discipline is to ensure that the graduates from the training acquire the all the relevant knowledge to make judicious decision, using the available resources, to manage both rare and common obstetric and gynecological conditions in a professional code of conduct. Given the fact that reproductive health related condition contribute to nearly 60% of the disease burden in Somalia, yet there are barely any teaching hospitals for graduate training locally, its paramount that we launch this training in our country. Overall Goal: to have the capacity to training obstetricians/ gynecologists who are competent in obstetrics and Gynecology, and research methods. We also aim to have our graduates who will have the capacity to mentor and supervise health workers below them.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three (3) years.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 1800`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September Intake`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Medicine in obstetrics and gynecology`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 100
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous University
    6. He/ She should have bachelor degree in Medicine
    7. At least 1 years Work experience in related Field Areas.`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `The Master of Science degree course in Obstetrics and Gynecology shall cover a minimum of Six (6) semesters and a maximum of ten (10) semesters of fifteen (15) weeks each. A candidate shall be required to take a minimum of three (3) course units and a maximum of five (5) course units in a semester. The course shall consist of fifteen (15) units of sixty (60) hours each, a practicum and project. Progressive assessment is based on clinical care of patients, case write-ups and presentations as well as thoroughness of clinical records. The most crucial clinical skills and procedures will be assessed through the use of assessment cards and or a log book designed by the department. An external examiner is present at the examinations of the year 3, semester 2 courses.                                                                       The course shall be conducted through lectures, seminars, tutorials, laboratory, practical and Operative Obstetrics and Gynecology. The first year of study shall be by course work, tutorial, seminars, continuous assessment and end of year examinations. A candidate shall only proceed to the second year of study after successful completion of the first year examination. In the second year of study, candidates shall take up an attachment /practicum in a discipline of their interest. They shall develop a research proposal so as to conduct original research, write a dissertation and sit for the final year examinations.`,
    icon: icon7,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Obstetrics and gynecology is the medical specialty the covers pregnancy, childbirth and the health of female reproductive system. Obstetrics and gynecology is a hugely rewarding area of medicine to specialize in the society. Pursuing a career in women’s healthcare is an incredible opportunity for those who excel in communication, empathy, stamina and problem-solving. There’s fantastic scope to make a real difference to people’s lives and to the science and practice of Obstetrics and gynecology more broadly. Working in obstetrics provides plenty of career opportunities and personal development within the medical profession, with opportunities both in surgical and medical. Obstetrics and gynecology is all about working in women’s health, a career that can be one of the most rewarding of all on a number of levels. Childbirth and maternity care plays a vital and pivotal role in the medical profession. When working with pregnant women and sensitive women’s issues, it can be very personal and positive relationships between the doctors and patients are developed along the way. Women not only require a medical expert during this major phase of their lives, but also someone they feel they can trust, rely on and confide in at all times. It’s like being a friend, personal consultant and medical expert all rolled into one. As a professional in this field, your passion for supporting women through health crises, pregnancy and maternity care will drive you forward.`,
    icon: icon9,
  },
];

export const public_health_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The development of the Master of Public Health (MPH) program at Bendir University was informed by the challenges posed by the two decades of war that has heightened disparities in health and health care for the both the rural and urban populations and other underserved populations such as pastoralist communities in Somalia.  The prolonged nature of the two decade conflict in the Federal Republic of Somalia has not only led to the collapse of infrastructure and governance structures, but has also led to a total breakdown of the health care system. As such, a large segment of the Somali population is without access to basic health services and with complete absence of some higher level services in many regions. According to an assessment on human resource for health conducted in 2009 by WHO, UNICEF and UNFPA in Somalia, there is an acute shortage of professional health manpower (of all forms of health cadres) at all levels with significant rural-urban disparities. 
    With the concentration of poverty, low health status and high burden of disease especially in Somalia, there is a need to focus specifically on improving the health of people in rural and remote areas, particularly if the urban drift is to be reversed. It is evident that a critical mass of trained professionals in MPH is needed to provide technical expertise at both the policy and programmatic levels. Deliberate efforts must therefore be undertaken in training this cadre of human resource to support the health care system. It is in response to this need, that Benadir University in collaboration with Makerere University School of Public Health, Somalia Ministry of Health and partners developed a training programme leading to a Master of Public Health that will be offered at its newly established department of the Public Health School of Post Graduate Studies. The graduates of this programme will be placed to provide leadership and management in this effort at national and local government levels. The graduates will be able to work in health, nutrition-related health services, education and research in specialised fields of public health.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Two(2) years`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 750`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Public Health`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $100
    2. Two (2) copies of photos with white background  
    3. Original of Secondary School certificate, 
    4. Original of Bachelor certificate & Transcript   
    5. Two (2) Recommendation letters from your Previous University
    6. He/ She should have bachelor degree in Medicine, Health science and bachelor degree in Field or related programs.`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `The Department of Community Health proposes to start an innovative multidisciplinary postgraduate course in order to train experts capable of meeting the emerging challenges in the field of health. Over the past 18 years, the Department has exclusively accommodated medical disciplines in the Master of Public Health (MPH) programme. 
    The recognition that multidisciplinary teams are required in addressing health has necessitated the need to train clinicians together with persons of diverse professional backgrounds such as sociologists, nutritionists, environmentalists, health planners and nurses among others. 
    Currently, this integrated approach in training specialists in Masters of Public Health is a common practice worldwide. Subsequently, there has been a high demand for the MPH degree from persons with diverse professional backgrounds. In order to accommodate candidates with the requisite professional backgrounds into the MPH degree, the Department has restructured the graduate programme with the aim of expanding the criteria for admission into the MPH degree course.`,
    icon: icon7,
  },
  {
    id: 8,
    title: "Career Options",
    desc: `Earning your master’s degree in public health opens the door to a wealth of career opportunities in different fields. No matter which field you choose, you could be making a difference in people’s lives on a large scale. Master’s in Public Health graduates can work for community clinics, federal, state, or local health agencies, hospitals, non-profits, private foundations, and more. Through program policies, research, and community partnerships, public health professionals are dedicated to seeking solutions for well-being worldwide.`,
    icon: icon9,
  },
];


export const hrmDetail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The Master of Human Resource Management (MHRM) is a specialized postgraduate program tailored to offer comprehensive knowledge and skills in the field of human resource management. It is specifically designed for individuals aspiring to advance their careers in HRM or assume leadership roles within organizations.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three semesters with in 18 Months`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 2000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `Intake 1:  September.\nIntake 2:  April.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Science in Human Resource Management `,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
1.	Processing fee of USD $ 100 
2.	Two (2) copies of photos with white background 
3.	Original of Secondary School certificate, 
4.	Original of Bachelor certificate & Transcript 
5.	Two (2) Recommendation letters from your Previous university
6.	He/ She should have bachelor’s degree in Statistics and Planning or related programs. 
7.	At least 2 years Work experience in related Field Areas.
`,
    icon: icon6,
  },
  
  {
    id: 9,
    title: "Career Options",
    desc: `A Master of Human Resource Management (MHRM) equips graduates with the necessary skills to identify, analyze, and resolve complex human resource and management challenges faced by organizations. The program covers various areas including human resource policy, human resource development, and industrial relations. As a result, MHRM graduates can pursue diverse career paths, such as:
1.	Human Resources Manager
2.	HR Consultant
3.	Talent Acquisition Specialist
4.	Compensation and Benefits Manager
5.	Training and Development Manager
6.	Employee Relations Specialist
7.	HR Analyst
8.	Organizational Development Specialist
9.	HR Entrepreneur
10.	Labor Relations Manager`,
    icon: icon9,
  },
];

export const MEDetail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The goal of the Master of Monitoring and Evaluation (MME) program is to give students the abilities and information required to evaluate and enhance the efficacy of policies and programs in a range of industries, such as international development, social services, health, and education.

Program Goals:

- Develop Core Competencies: Give students the foundational knowledge and skills necessary to plan, carry out, and assess tests successfully. 
- Improve Analytical Skills: Develop analytical and critical thinking abilities for a detailed analysis of program data and results.
- Apply the Results to Decision-Making: Teach students to use assessment data to inform program and policy decisions so that interventions are relevant and successful. 
- Research Methods Foundation: Give students a solid foundation in both qualitative and quantitative research methods so they may conduct in-depth analyses. 
- Involve Stakeholders: Stress the significance of involving different stakeholders in the assessment procedure to guarantee applicability and backing. 
- Promote Innovation: Encourage students to find and use cutting-edge instruments and techniques for practices in monitoring and assessment.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three semesters with in 18 Months`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 100 \nTuition Fee : $ 2000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `Intake 1:  September – November.\nIntake 2:  January – February .`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Monitoring and Evaluation`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
1.	Processing fee of USD $ 100 
2.	Two (2) copies of photos with white background 
3.	Original of Secondary School certificate, 
4.	Original of Bachelor certificate & Transcript 
5.	Two (2) Recommendation letters from your Previous university
6.	He/ She should have bachelor’s degree in business administration or related programs. 
7.	At least 2 years Work experience in related Field Areas.
`,
    icon: icon6,
  },
  
  {
    id: 9,
    title: "Career Options",
    desc: `Career choices for graduates with a master's degree in monitoring and evaluation are broad and include positions as data analysts, monitoring specialists, and evaluators. In addition, they can serve as research consultants, policy advisors, and program managers. Impact assessment experts, grant writers or administrators, and capacity building specialists are other prospects. A few graduates might go into research and teaching positions in academia, which would further the field's development`,
    icon: icon9,
  },
];


// postgraduate diploma details 

export const daf_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `A postgraduate diploma in accounting and finance is a one-year program that is designed for students who hold an undergraduate degree in any field of not accounting or an unrelated field. The program provides an in-depth understanding of accounting principles, financial management, taxation, auditing, and other related subjects.\n\nThe program is designed to prepare students for careers in accounting, finance, auditing, and taxation in various sectors such as government, non-profit organizations, and private companies.
    `,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Two semesters with in 12 months `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 50 \nTuition Fee : $ 1000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Postgraduate Diploma in Accounting and Finance, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 50
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous university  
    6. He/ She should have bachelor degree in the field or related programs`,
    icon: icon6,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Graduates can pursue careers as accountants, auditors, financial analysts, tax consultants, or financial managers. The professional certifications such as Chartered Accountants or Certified Public Accountants, can add value to the qualification and help graduates in their career advancement.`,
    icon: icon9,
  },
];


export const de_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The Postgraduate Diploma in Economics is a specialized program designed for individuals who possess a background in economics or a related field and seek to advance their knowledge and skills in this field. The program provides an in-depth understanding of economic theories, principles, and applications, and aims to equip students with the necessary skills to analyze and interpret economic data, make informed economic decisions, and formulate economic policies.
    `,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Two semesters with in 12 months `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 50 \nTuition Fee : $ 1000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Postgraduate Diploma in Economics, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 50
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous university  
    6. He/ She should have bachelor degree in the field or related programs`,
    icon: icon6,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Graduates of the program can pursue careers in a variety of sectors, including government agencies, international organizations, financial institutions, research organizations, non-governmental organizations, and academia.`,
    icon: icon9,
  },
];

export const dpl_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `A Postgraduate Diploma in Procurement and Logistics Management is a specialized program that provides students with advanced knowledge and skills in the procurement and logistics management field. The curriculum of the program covers various aspects of procurement and logistics, such as procurement planning, sourcing, negotiation, and contract management, supply chain management, inventory control, transportation, and distribution management.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Two semesters with in 12 months `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 50 \nTuition Fee : $ 1000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Postgraduate Diploma in Procurement and Logistics, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 50
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous university  
    6. He/ She should have bachelor degree in the field or related programs`,
    icon: icon6,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Graduates of the program often go on to work in various positions such as procurement managers, logistics managers, supply chain managers, and operations managers.`,
    icon: icon9,
  },
];

export const dhrm_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The postgraduate diploma in human resource management is a comprehensive course that aims to equip students with the skills and knowledge necessary to excel in the field of HR management. The course is designed to provide an in-depth understanding of the various aspects of human resource management, including recruitment, performance management, employee relations, training and development, benefits administration, and compensation management.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Two semesters with in 12 months `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 50 \nTuition Fee : $ 1000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Postgraduate Diploma in Human Resource Management, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 50
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous university  
    6. He/ She should have bachelor degree in the field or related programs`,
    icon: icon6,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `At the completion of this program, you will be able to work on the following area:
    1.	Human Resource Manage
2.	Compensation and Benefits Analyst
3.	Training and Development Specialist
4.	Employee Relations Manager
5.	HR Consultant
6.	Organizational Development Specialist
`,
    icon: icon9,
  },
];

export const dibf_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `A postgraduate diploma in Islamic banking is a specialized academic program that provides in-depth knowledge and understanding of the principles and practices of Islamic finance and banking. The course covers various aspects of Islamic finance, including the prohibition of interest-based transactions, profit and loss sharing, Takaful (Islamic insurance), and Sukuk (Islamic bonds). It equips students with knowledge and skills to develop Shariah-compliant financial products and services, conduct Islamic banking operations, and manage Islamic banking institutions effectively.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Two semesters with in 12 months `,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registeration Fee : 50 \nTuition Fee : $ 1000`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `There are two intakes in every year.\n\tJanuary Intake\n\tSeptember  Intake.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Postgraduate Diploma in Human Resource Management, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `
    1. Processing fee of USD $ 50
    2. Two (2) copies of photos with white background
    3. Original of Secondary School certificate,
    4. Original of Bachelor certificate & Transcript
    5. Two (2) Recommendation letters from your Previous university  
    6. He/ She should have bachelor degree in the field or related programs`,
    icon: icon6,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `
1.	Shariah Compliance Officer
2.	Relationship Manager
3.	Investment Analyst
4.	Risk Manager
5.	Financial Planner
6.	Product Development Specialist
7.	Shariah Auditor
8.	Islamic Wealth Manager
`,
    icon: icon9,
  },
];

export const detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `no content yet`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `no content yet`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `no content yet`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `no content yet`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `no content yet`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `no content yet`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `no content yet`,
    icon: icon7,
  },
  {
    id: 8,
    title: "Modules and Assessments",
    desc: `no content yet`,
    icon: icon8,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `no content yet`,
    icon: icon9,
  },
];

export const ophthalmology_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The Master of Medicine in Ophthalmology (MMed Ophthalmology) is an advanced postgraduate medical training program designed to develop specialists who are competent in the prevention, diagnosis, medical management, surgical treatment, and rehabilitation of eye diseases. The program combines theoretical knowledge, clinical training, ophthalmic surgery, research, and professional development to prepare graduates for independent specialist practice and leadership in eye-care services.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three (3) years.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registration Fee : $ 100\nTuition Fee : $ 900 per semester`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September Intake every year.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Medicine in Ophthalmology, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `1. Original of Bachelor certificate & Transcript — MBChB/MBBS
2. Two (2) Recommendation letters from your Previous University
3. Minimum 1 year of post-internship experience
4. File/folder for document submission
5. Two (2) copies of passport-size photos with a white background
6. Original of Secondary School certificate
7. Registration fee of USD $100`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `This outline provides a structured framework for a Master of Medicine in Ophthalmology program, offering a balance of core courses, specialized ophthalmic subjects, clinical and surgical training, research activities, and practical experiences to prepare students for professional roles as specialist ophthalmologists. Actual program structures may vary depending on the institution and specific program requirements.

Typical course structure and subjects: Advanced Clinical Ophthalmology, Cornea and External Eye Diseases, Cataract and Anterior Segment Surgery, Glaucoma and Glaucoma Surgery, Retina and Vitreous Diseases, Neuro-Ophthalmology, Pediatric Ophthalmology, Strabismus and Ocular Motility Disorders, Oculoplasty and Orbital Diseases, Lacrimal and Adnexal Diseases, Uveitis and Ocular Immunology, Ocular Oncology and Eye Tumors, Ophthalmic Trauma and Emergencies, Refractive Errors and Clinical Refraction, Ophthalmic Diagnostic Imaging and Investigations, Community Ophthalmology and Prevention of Blindness, Low-Vision Rehabilitation, Ophthalmic Pharmacology and Therapeutics, Ophthalmic Surgery and Microsurgical Techniques, Research Methods and Biostatistics, Evidence-Based Ophthalmology, Clinical Epidemiology, Clinical Training and Supervised Practical Experience, Case Presentations and Clinical Seminars, Thesis Research and Thesis Defense.`,
    icon: icon7,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Graduates of a Master of Medicine in Ophthalmology may pursue professional careers in a variety of clinical, academic, research, and leadership settings. Career opportunities may include: Consultant Ophthalmologist, Specialist Ophthalmologist, Ophthalmic Surgeon, Cataract and Anterior Segment Specialist, Glaucoma Specialist, Vitreoretinal Specialist, Cornea and External Eye Disease Specialist, Pediatric Ophthalmologist, Neuro-Ophthalmologist, Oculoplastic and Orbital Specialist, Ophthalmic Trauma and Emergency Specialist, Community Ophthalmology and Eye Health Specialist, Low-Vision and Rehabilitation Specialist, Medical University Lecturer, Clinical Researcher, Ophthalmology Department Coordinator, Eye-Care Program Manager, Hospital Ophthalmology Service Manager, and Public Health or Blindness-Prevention Program Specialist.`,
    icon: icon9,
  },
];

export const one_health_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The Master of Science in One Health (MSc One Health) is an advanced postgraduate program designed to develop professionals with the knowledge and skills to address complex health challenges at the intersection of human, animal, and environmental health. The program emphasizes an integrated and multidisciplinary approach to disease prevention, health promotion, food safety, environmental health, zoonotic diseases, antimicrobial resistance, and emerging health threats. It combines theoretical knowledge, practical experience, research, field training, data analysis, and professional development to prepare graduates for careers in public health, veterinary health, environmental health, research, and One Health program leadership.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Two (2) years.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registration Fee : $ 100\nTuition Fee : $ 750 per semester`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September Intake every year.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Science in One Health, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `1. Original Bachelor certificate & Transcript — bachelor's degree in Medicine, Veterinary Medicine, Public Health, Nursing, Environmental Health, Biology, Biomedical Sciences, Agriculture, or a related health or life-science field
2. Two (2) Recommendation letters from your Previous University
3. Relevant professional or work experience may be required depending on the applicant's academic background and institutional requirements
4. File/folder for document submission
5. Two (2) copies of passport-size photos with a white background
6. Original of Secondary School certificate
7. Registration fee of USD $100`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `This outline provides a structured framework for a Master of Science in One Health program, offering a balance of core courses, specialized subjects, interdisciplinary learning, field-based practical experiences, research activities, and professional development to prepare students for professional roles in One Health, public health, veterinary health, environmental health, and related sectors. Actual program structures may vary depending on the institution and specific program requirements.

Typical course structure and subjects: Foundations and Principles of One Health, Human Health and Public Health, Veterinary and Animal Health, Environmental Health and Ecosystem Health, Zoonotic and Vector-Borne Diseases, Emerging and Re-Emerging Infectious Diseases, Epidemiology and Disease Surveillance, Integrated Disease Surveillance and Response, Food Safety and Foodborne Diseases, Antimicrobial Resistance and One Health, Environmental Microbiology, Wildlife Health and Conservation, Climate Change and Health, Global Health and One Health, Health Security and Pandemic Preparedness, Outbreak Investigation and Response, Biosafety and Biosecurity, Risk Assessment and Health Impact Assessment, GIS and Spatial Epidemiology, Data Management and Analytics, Research Methods and Biostatistics, Evidence-Based One Health, Health Policy and Systems, One Health Governance and Leadership, Community Engagement and Health Promotion, One Health Field Practicum, Case Presentations and Interdisciplinary Seminars, Research Project and Thesis, Thesis Writing and Thesis Defense.`,
    icon: icon7,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Graduates of a Master of Science in One Health may pursue professional careers in a variety of public health, veterinary, environmental, research, academic, governmental, humanitarian, and international health settings. Career opportunities may include: One Health Specialist, Public Health Specialist, Epidemiologist, Disease Surveillance Specialist, Zoonotic Disease Specialist, Veterinary Public Health Specialist, Environmental Health Specialist, Food Safety Specialist, Antimicrobial Resistance Specialist, Outbreak Investigation Specialist, Global Health Specialist, One Health Program Coordinator, Health Security and Pandemic Preparedness Specialist, Researcher, University Lecturer, Public Health Program Manager, One Health Project Manager, Wildlife and Conservation Health Specialist, GIS and Spatial Epidemiology Specialist, Monitoring and Evaluation Specialist, Health Policy and Systems Specialist, Laboratory and Biosafety Specialist, and International Health or Humanitarian Program Specialist.`,
    icon: icon9,
  },
];

export const anesthesia_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The Master of Medicine in Anesthesia (MMed Anesthesia) is an advanced postgraduate medical training program designed to develop specialists who are competent in the assessment and preparation of patients for anesthesia, administration and management of general and regional anesthesia, perioperative medicine, pain management, critical care, and the management of anesthesia-related emergencies. The program combines theoretical knowledge, clinical training, practical experience, research, and professional development to prepare graduates for independent specialist practice and leadership roles in anesthesia and perioperative care.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three (3) years.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registration Fee : $ 100\nTuition Fee : $ 1200 per semester`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September Intake every year.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Medicine in Anesthesia, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `1. Original Bachelor certificate & Transcript — MBChB/MBBS
2. Two (2) Recommendation letters from your Previous University
3. Minimum 1 year of post-internship experience
4. File/folder for document submission
5. Two (2) copies of passport-size photos with a white background
6. Original of Secondary School certificate
7. Registration fee of USD $100`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `This outline provides a structured framework for a Master of Medicine in Anesthesia program, offering a balance of core courses, specialized anesthesia and perioperative subjects, clinical training, practical experiences, research activities, and professional development to prepare students for professional roles as specialist anesthesiologists. Actual program structures may vary depending on the institution and specific program requirements.

Typical course structure and subjects: Basic and Applied Anesthesia Sciences, Advanced General Anesthesia, Regional Anesthesia and Nerve Blocks, Airway Management and Difficult Airway, Anesthesia Pharmacology, Anesthesia Equipment and Monitoring, Cardiovascular Anesthesia, Thoracic Anesthesia, Neuroanesthesia, Obstetric Anesthesia, Pediatric Anesthesia, Geriatric Anesthesia, Trauma and Emergency Anesthesia, Anesthesia for General and Specialized Surgery, Orthopedic and Spine Anesthesia, ENT and Ophthalmic Anesthesia, Urological Anesthesia, Ambulatory and Day-Case Anesthesia, Critical Care Medicine, Perioperative Medicine, Acute and Chronic Pain Management, Resuscitation and Advanced Life Support, Anesthesia Complications and Patient Safety, Preoperative Assessment and Optimization, Postoperative Care and Recovery, Research Methods and Biostatistics, Evidence-Based Anesthesia, Clinical Epidemiology, Clinical Training and Supervised Practical Experience, Case Presentations and Clinical Seminars, Thesis Research and Thesis Defense.`,
    icon: icon7,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Graduates of a Master of Medicine in Anesthesia may pursue professional careers in a variety of clinical, academic, research, critical care, pain management, and healthcare leadership settings. Career opportunities may include: Consultant Anesthesiologist, Specialist Anesthesiologist, General Anesthesia Specialist, Regional Anesthesia Specialist, Obstetric Anesthesia Specialist, Pediatric Anesthesia Specialist, Cardiothoracic Anesthesia Specialist, Neuroanesthesia Specialist, Trauma and Emergency Anesthesia Specialist, Critical Care Specialist, Pain Management Specialist, Perioperative Medicine Specialist, Anesthesia Department Coordinator, Intensive Care Unit Specialist, Medical University Lecturer, Clinical Researcher, Hospital Anesthesia Service Manager, Perioperative Care Program Manager, and Patient Safety or Quality Improvement Specialist.`,
    icon: icon9,
  },
];

export const dermatology_detail = [
  {
    id: 1,
    title: "Course Overview",
    desc: `The Master of Medicine in Dermatology & Venereology is a postgraduate medical specialization program designed to provide advanced knowledge, clinical skills, and practical training in the diagnosis, treatment, and prevention of skin, hair, nail, mucosal, and sexually transmitted diseases. The program combines theoretical education, clinical training, case discussions, diagnostic procedures, research, and supervised practical experience to prepare medical doctors for professional practice in Dermatology and Venereology.`,
    icon: icon1,
  },
  {
    id: 2,
    title: "Duration",
    desc: `Three (3) years.`,
    icon: icon2,
  },
  {
    id: 3,
    title: "Program Fee",
    desc: `Registration Fee : $ 100\nTuition Fee : $ 900 per semester`,
    icon: icon3,
  },
  {
    id: 4,
    title: "Intake",
    desc: `September Intake every year.`,
    icon: icon4,
  },
  {
    id: 5,
    title: "Award",
    desc: `Master of Medicine in Dermatology & Venereology, Benadir University`,
    icon: icon5,
  },
  {
    id: 6,
    title: "Entry Requirements",
    desc: `1. Original of Bachelor certificate & Transcript — MBChB/MBBS
2. Two (2) Recommendation letters from your Previous University
3. Minimum 1 year of post-internship experience
4. File/folder for document submission
5. Two (2) copies of passport-size photos with a white background
6. Original of Secondary School certificate
7. Registration fee of USD $100`,
    icon: icon6,
  },
  {
    id: 7,
    title: "Program Outline",
    desc: `This outline provides a structured framework for a Master of Medicine in Dermatology & Venereology program, offering a balance of core courses, specialized subjects, clinical training, research activities, and practical experiences to prepare students for professional roles as specialists in dermatology and venereology. Actual program structures may vary depending on the institution and specific program requirements.

Typical course structure and subjects: Advanced Clinical Dermatology, Dermatopathology and Skin Immunology, Infectious and Tropical Dermatology, Sexually Transmitted Infections and Venereology, Pediatric Dermatology, Autoimmune and Connective Tissue Diseases, Dermatologic Oncology and Skin Cancer, Hair and Nail Disorders, Pigmentary Disorders, Dermatologic Surgery and Procedural Dermatology, Diagnostic Dermatology and Dermoscopy, Advanced and Cosmetic Dermatology, Dermatological Emergencies, Clinical Pharmacology in Dermatology, Research Methods and Biostatistics, Evidence-Based Dermatology, Clinical Epidemiology, Clinical Training and Supervised Practical Experience, Case Presentations and Clinical Seminars, Thesis Research and Thesis Defense.`,
    icon: icon7,
  },
  {
    id: 9,
    title: "Career Options",
    desc: `Graduates of the Master of Medicine in Dermatology & Venereology program can pursue a wide range of professional opportunities in clinical practice, hospitals, healthcare institutions, academic settings, research organizations, and public health programs. Typical career options include: Dermatologist, Consultant Dermatologist, Venereologist, Clinical Dermatology Specialist, Dermatologic Surgeon, Pediatric Dermatology Specialist, Dermatopathology Specialist, Cosmetic Dermatology Specialist, Dermatology and STI Clinic Specialist, Hospital Dermatology Specialist, Medical Educator and Lecturer, Clinical Researcher, Public Health Specialist in Skin and STI Programs, and Specialist in Dermatological and Cosmetic Procedures.`,
    icon: icon9,
  },
];
